import { environment } from "../../environments/environment";

export const defaultRedirectTimeout: number = Number(
  environment.timeoutRedirectMs
);
